<app-label-value class="col-sm" label="Nom" [value]="contact().lastname"></app-label-value>
<app-label-value class="col-sm" label="Prénom" [value]="contact().firstname"></app-label-value>
<app-label-value
  class="col-sm phone"
  label="Téléphone"
  [value]="contact().phoneNumber"
></app-label-value>
<app-label-value class="col-sm email" label="Email" [value]="contact().email"></app-label-value>
